import Player from '@vimeo/player';
import $ from 'jquery';

document.addEventListener('DOMContentLoaded', function () {
	let vimeoIframe: HTMLIFrameElement | null = document.querySelector('.landing-video iframe');
	let isQuestionPage = false;
	const landingInput = document.querySelector('#landing-input') as HTMLInputElement;
	const landingSubmitBtn = document.querySelector('#landing-submitbtn') as HTMLButtonElement;
	const landingQuestion = document.querySelector('.landing-question');
	const landingWrap = document.querySelector('.landing-main-wrapper');
	const landingMain = document.querySelector('.landing-main');

	if (landingSubmitBtn) {
		landingSubmitBtn.addEventListener('click', function (e) {
			e.preventDefault();
			const commentForm = document.querySelector('#commentform');
			if (commentForm) {
				commentForm.dispatchEvent(new Event('submit'));
			}
		});
	}

	if (landingQuestion) {
		const landingQuestionStyles = window.getComputedStyle(landingQuestion);
		isQuestionPage = landingQuestionStyles.display !== 'none';
	}

	function initInput() {
		const questionH2 = document.querySelector('.landing-question h2') as HTMLElement;
		const defaultContent = questionH2.getAttribute('data-default');
		questionH2.innerHTML =
			defaultContent +
			'<span class="landing-question-placeholder" aria-hidden="true"><span class="landing-question-indicator">|</span>Start typing</span>';
	}

	function focusLandingInput() {
		console.log('focusLandingInput')
		if (landingQuestion) {
			landingInput.focus();
			landingQuestion.classList.add('focus');
			window.scrollTo({ top: landingQuestion.offsetTop - landingQuestion.offsetHeight + (0*16), behavior: 'smooth' });
		}
	}

	function toggleVideo() {
		if (vimeoIframe !== null) {
			const player = new Player(vimeoIframe);
			const landing = document.querySelector('.landing-wrapper');
			player.getPaused().then(function (paused) {
				if (paused) {
					console.log('play');
					player.play();
					landing && landing.classList.remove('is-paused');
				} else {
					player.pause();
					landing && landing.classList.add('is-paused');
				}
			});
		}

		const landingControllersVideo = document.querySelector('.landing-controllers-video');
		if (landingControllersVideo) {
			landingControllersVideo.classList.toggle('landing-controllers-video--paused');
		}
	}

	function setLandingQuestion() {
		if (landingQuestion && !landingQuestion.classList.contains('hide')) {
			landingQuestion.classList.toggle('hide');
			landingQuestion.classList.toggle('focus');
			toggleControllers();
		}
	}

	// Utility function to toggle controllers
	function toggleControllers() {
		const landingControllersVideo = document.querySelector('.landing-controllers-video');
		const landingControllersClose = document.querySelector('.landing-controllers-close');
		if (landingControllersVideo && landingControllersClose) {
			landingControllersVideo.classList.toggle('hide');
			landingControllersClose.classList.toggle('hide');
		}
	}

	function handleLinkClick(item: HTMLElement, page: string) {
		const commonClass = 'landing-link';
		const commonClassSelector = `.${commonClass}`;
		const activeLandingLinksButtons = document.querySelectorAll('.landing-links .landing-links-item');
		if (!item.classList.contains('active')) {
			activeLandingLinksButtons.forEach(function (button) {
				button.classList.remove('active');
				let buttonElement = button as CustomHTMLElement;
				buttonElement.style.opacity = '0.5';
			});
		}
		if (item.classList.contains('landing-links-item')) {
			item.classList.add('active');
			let itemElement = item as CustomHTMLElement;
			itemElement.style.opacity = '1';
		}

		document.querySelectorAll(commonClassSelector).forEach(link => {
			link.classList.remove('active');
		});
		item.classList.add('active');

		const landingInfo = document.querySelector(`.landing-info[data-page="${page}"]`);
		if (landingInfo) {
			document.querySelectorAll('.landing-info').forEach(info => {
				info.classList.remove('active');
			});

			landingInfo.classList.add('active');

			// const landingInfoItems = document.getElementsByClassName('landing-info-comments')[0].classList.add('show');

			const landingLinksItem = document.querySelector('.landing-links-item[data-page="landing-responses"]') as CustomHTMLElement | null;
			if (landingLinksItem) {
				landingLinksItem.focus();
				landingLinksItem.scrollTop = 0;
			}
		}

		if (landingWrap) {
			landingWrap.classList.remove('is-question');
		}

		const landingLinks = document.querySelector('.landing-links');
		if (landingLinks) {
			landingLinks.classList.remove('active');
		}

		setLandingQuestion();

		if (vimeoIframe !== null) {
			const player = new Player(vimeoIframe);
			player.getPaused().then(function (paused) {
				if (!paused) {
					toggleVideo();
				}
			});
		}

		return false;
	}

	function delayedFocusLandingInput() {
		setTimeout(() => {
			focusLandingInput();
		}, 2000);
	}

	// Event listener for submitting
	const commentForm = document.querySelector('#commentform');
	if (commentForm) {
		commentForm.addEventListener('submit', function (e) {
			const $form = $(this);
			e.preventDefault();
			const form = e.target as HTMLFormElement;
			const landingInput = form.querySelector('#landing-input') as HTMLInputElement;
			const value = landingInput.value;
			if (value !== '') {
				$.post(
					$form.attr('action') || '',
					$form.serialize())
				.fail(function(data, response) {
					// alert($(response).text() || 'Something went horribly wrong, the team is on it.');
					return false;
				});
				
				const reply = document.createElement('li');
				reply.textContent = value;
				const landingInfoComments = document.querySelector('.landing-info-comments');
				if (landingInfoComments) {
					landingInfoComments.prepend(reply);
				}
			}
			landingInput.value = '';
			initInput();
			landingInput.blur();

			const landingLinksItem = document.querySelector('.landing-links-item[data-page="landing-responses"]') as CustomHTMLElement | null;
			if (landingLinksItem) {
				landingLinksItem.dispatchEvent(new Event('click'));
				landingLinksItem.focus();
			}
		});
	}

	// Event listener for landing toggle click
	const landingToggle = document.querySelector('.landing-toggle');
	if (landingToggle) {
		landingToggle.addEventListener('click', function () {
			const landingLinks = document.querySelector('.landing-links');
			if (landingLinks) {
				if (!landingLinks.classList.contains('active')) {
					if (landingWrap) {
						if (landingWrap.classList.contains('is-question')) {
							landingWrap.classList.remove('is-question');
						}
						if (!landingWrap.classList.contains('is-menu')) {
							landingWrap.classList.add('is-menu');
						}
					}
					landingLinks.classList.toggle('active');
					const activeLi = landingLinks.querySelector('li.active');
					if (activeLi) {
						activeLi.classList.remove('active');
					}
					const activeLandingInfo = document.querySelector('.landing-info.active');
					if (activeLandingInfo) {
						activeLandingInfo.classList.remove('active');

						// const landingInfoItems = document.getElementsByClassName('landing-info-comments')[0].classList.remove('show');
					}

					setLandingQuestion();
				}
			}
		});
	}

	// Event listener for links click and Enter key events
	const landingLinksItems = document.querySelectorAll('.landing-links-item');
	if (landingLinksItems) {
		Array.from(landingLinksItems).forEach(function (item) {
			const element = item as HTMLElement;
			element.addEventListener('click', function () {
				const page = element.getAttribute('data-page');
				if (page) {
					handleLinkClick(element, page);
					if (landingWrap && landingWrap.classList.contains('is-menu')) {
						landingWrap.classList.remove('is-menu');
					}
				}
			});
			element.addEventListener('keydown', function (event) {
				if (event.key === 'Enter') {
					event.preventDefault();
					element.click();
				}
			});
		});
	}

	// Event listener for landingControllersClose click
	const landingControllersClose = document.querySelector('.landing-controllers-close');
	if (landingControllersClose) {
		landingControllersClose.addEventListener('click', function () {
			if (landingQuestion) {
				landingQuestion.classList.toggle('hide');
				const activeLandingLinksLi = document.querySelector('.landing-links li.active');
				if (activeLandingLinksLi) {
					activeLandingLinksLi.classList.remove('active');
				}
				const activeLandingLinksButtons = document.querySelectorAll('.landing-links .landing-links-item');
				if (activeLandingLinksButtons) {
					activeLandingLinksButtons.forEach(function (item) {
						item.classList.remove('active');
						let itemElement = item as CustomHTMLElement;
						itemElement.style.opacity = '1';
					});
				}

				const activeLandingInfo = document.querySelector('.landing-info.active');
				if (activeLandingInfo) {
					activeLandingInfo.classList.remove('active');
				}
				const landingLinks = document.querySelector('.landing-links');
				if (landingLinks) {
					landingLinks.classList.remove('active');
				}
				toggleControllers();

				if (landingQuestion) {
					landingQuestion.dispatchEvent(new Event('click'));
				}

				if (landingWrap) {
					if (!landingWrap.classList.contains('is-question')) {
						landingWrap.classList.add('is-question');
					}
					if (landingWrap.classList.contains('is-menu')) {
						landingWrap.classList.remove('is-menu');
					}
				}
				return false;
			}
		});
	}

	// Event listener for keyboard controls
	document.addEventListener('keydown', function (e) {
		// Close landing info
		const landingControllersClose = document.querySelector('.landing-controllers-close');
		if (e.key === 'Escape' && landingControllersClose instanceof HTMLElement && landingControllersClose.offsetParent !== null) {
			landingControllersClose.dispatchEvent(new Event('click'));
		}
		// Focus landing input
		if (landingInput && landingInput === document.activeElement) {
			if (e.key === 'Tab' && !e.shiftKey) {
				e.preventDefault();
				if (landingSubmitBtn instanceof HTMLButtonElement) {
					landingSubmitBtn.focus();
				}
				if (landingSubmitBtn.disabled) {
					const landingLinksItem = landingLinksItems[0] as HTMLElement;
						if (landingLinksItem) {
						landingLinksItem.focus();
					}
				}
			}
		}
		// Focus landing submit button and handle Enter key
		if (landingSubmitBtn === document.activeElement && e.key === 'Enter') {
			e.preventDefault();
			if (!landingSubmitBtn.disabled) {
				landingSubmitBtn.click();
			}
		}
		// All Possibilities & Share Info active
		const activeInfoElements = document.querySelectorAll('.landing-info[data-page="landing-share"].active, .landing-info[data-page="landing-possibilities"].active');
		if (activeInfoElements.length > 0) {
			if (e.key === 'Tab' && !e.shiftKey) {
				const activeInfo = activeInfoElements[0];
				const focusableElements = activeInfo.querySelectorAll('a, button');
				// Check if any element in the list has focus
				const hasFocus = Array.from(focusableElements).some((el) => el === document.activeElement);
				if (hasFocus) {
					e.preventDefault();
					const activeElementIndex = Array.from(focusableElements).findIndex((el) => el === document.activeElement);
					// If the active element is the last one in the list, focus the close button
					if (activeElementIndex === focusableElements.length - 1) {
						const landingControllersClose = document.querySelector('.landing-controllers-close');
						if (landingControllersClose && landingControllersClose instanceof HTMLElement && landingControllersClose.offsetParent !== null) {
							landingControllersClose.focus();
						}
					} else {
						// Otherwise, focus the next element in the list
						const nextElement = focusableElements[activeElementIndex + 1];
						if (nextElement instanceof HTMLElement) {
							nextElement.focus();
						}
					}
				} else {
					// If no element has focus, focus the first element in the list
					e.preventDefault();
					const firstElement = focusableElements[0];
					if (firstElement instanceof HTMLElement) {
						firstElement.focus();
					}
				}
			}
		}
		// On focus last link
		const landingLinksItem = document.querySelector('button.landing-links-item[data-page="landing-share"]');
		if (landingLinksItem && landingLinksItem === document.activeElement) {
			if (e.key === 'Tab' && !e.shiftKey) {
				e.preventDefault();
				const landingControllersClose = document.querySelector('.landing-controllers-close');
				const landingControllersVideo = document.querySelector('.landing-controllers-video');
				if (landingControllersClose instanceof HTMLElement && landingControllersClose.offsetParent !== null) {
					landingControllersClose.focus();
				} else if (landingControllersVideo instanceof HTMLElement) {
					landingControllersVideo.focus();
				}
			}
		}
		// Skip content triggered
		const skipHeader = document.getElementById('skip-header');
		if (skipHeader && e.key === 'Enter' && !document.querySelector('.landing-question')?.classList.contains('focus') && isQuestionPage) {
			e.stopImmediatePropagation();
			e.preventDefault();
			if (landingQuestion) {
				landingQuestion.dispatchEvent(new Event('click'));
			}
		}
	});

	// Event listener for all questions click
	const landingInnerQuestions = document.querySelector('.landing-inner-questions');
	if (landingInnerQuestions) {
			const listItems = landingInnerQuestions.querySelectorAll('li');
			const numItems = listItems.length;

			if (numItems >= 2) {
					let activeIndexes = [0, 1]; // Initially, the first two items are active

					listItems.forEach((item, index) => {
							if (activeIndexes.includes(index)) {
									item.classList.add('active', `active--${activeIndexes.indexOf(index) + 1}`);
							}
					});

					landingInnerQuestions.addEventListener('click', function (e) {
							const target = e.target as Element;
							if (!target.matches('a')) {
									e.preventDefault();

									const currentActive = landingInnerQuestions.querySelectorAll('li.active');
									currentActive.forEach(item => {
											item.classList.remove('active');
											item.classList.remove('active--1');
											item.classList.remove('active--2');
									});

									// Toggle active indexes on click
									activeIndexes = activeIndexes.map(index => {
											const nextIndex = (index + 1) % numItems;
											return nextIndex;
									});

									activeIndexes.forEach((index, i) => {
											listItems[index].classList.add('active', `active--${i + 1}`);
									});
							}
					});
			} else {
				landingInnerQuestions.classList.add('has-one');
				if (listItems[0]) {
					listItems[0].classList.add('active', 'active--2');
				}
			}

			document.addEventListener('mousemove', function (e) {
				var xPercent = e.pageX / window.innerWidth * 100;
				if (xPercent < 50) {
					landingInnerQuestions.classList.remove('rightArrow');
					landingInnerQuestions.classList.add('leftArrow');
				}
				if (xPercent > 50) {
					landingInnerQuestions.classList.remove('leftArrow');
					landingInnerQuestions.classList.add('rightArrow');
			}});
	}

	// Check if questionVideo autoplay is allowed
	if (vimeoIframe !== null) {
		const questionVideo = new Player(vimeoIframe);
		questionVideo.play().catch(function (error) {
			// Handle autoplay error
			console.log('Video autoplay is not allowed:', error);
			const landingControllersVideo = document.querySelector('.landing-controllers-video');
			if (landingControllersVideo) {
				landingControllersVideo.classList.add('landing-controllers-video--paused');
			}
		});
	}

	// INIT when there's a question on the page
	if (landingQuestion) {
		// show landingMain after the vimeo is playing
		if (vimeoIframe !== null) {
			if (landingMain) {
				landingMain.classList.remove('hide');
			}
			// Probably a better way to do this..
			if (window.innerWidth > 500) {
				focusLandingInput();
			}
			landingQuestion.classList.add('focus');
			const questionH2 = document.querySelector('.landing-question h2') as HTMLElement;
			questionH2.addEventListener('click', focusLandingInput);
		}

		landingInput.addEventListener('input', function (e) {
			e.preventDefault();
			const questionH2 = document.querySelector('.landing-question h2') as HTMLElement;
			const defaultContent = questionH2.getAttribute('data-default');
			questionH2.innerHTML = defaultContent +
			(landingInput.value !== '' ? ' ' + landingInput.value : '') +
			'<span class="landing-question-indicator">|</span>';

			if (landingInput.value.length == 1) {
				toggleVideo();
			}

			if (landingInput.value.length >= 3) {
				landingSubmitBtn.removeAttribute('disabled');
			} else {
				landingSubmitBtn.setAttribute('disabled', 'true');
			}
		});

		landingInput.addEventListener('focusout', function () {
			if (landingQuestion) {
				landingQuestion.classList.remove('focus');
			}
		});
	}

	// Auto focus on tab change
	document.addEventListener('visibilitychange', function () {
		if (!document.hidden && landingQuestion) {
			delayedFocusLandingInput();
		}
	});

	const landingControllersVideo = document.querySelector('.landing-controllers-video');
	if (landingControllersVideo) {
		landingControllersVideo.addEventListener('click', toggleVideo);
	}
});
